import { trackMixpanel } from '../base';
import type { CarouselBaseProps } from './types';

const COMPONENT = 'Deliveries Carousel';
const EVENT_NAME = 'Impression';

export interface CarouselImpressionProps extends CarouselBaseProps {}

interface CarouselImpressionMixpanelProps {
    'Page Name': string;
    'Carousel Name': string;
    'Subcategory IDs': number[];
    'Number Of Saved Deliveries': number;
}

export const trackCarouselImpression = (props: CarouselImpressionProps) => {
    trackMixpanel(COMPONENT, EVENT_NAME, {
        'Page Name': props.pageName,
        'Carousel Name': props.carouselName,
        'Subcategory IDs': props.subCategoryIds,
        'Number Of Saved Deliveries': props.numberOfSavedDeliveries,
    } satisfies CarouselImpressionMixpanelProps);
};
